import React from "react";
import { CardShopComponent } from "./CardShopComponent";
import { useProductUnits } from "../Repository/useProductUnits";
import { OrderComponent } from "./OrderComponent";
import SearchComponent from "./SearchComponent";
import ProductDetailComponent from "./ProductDetailComponent";
import {useSearchParams} from "react-router-dom";

export function ProductUnitComponentWrapper(props) {
    const { units, loading, error } = useProductUnits();
    const [searchParams] = useSearchParams();
    const tableParam = searchParams.get('table_id');

    if (loading) {
        return <div style={{ textAlign: "center", padding: "2rem" }}>در حال بارگذاری واحدها...</div>;
    }

    if (error) {
        return <div style={{ color: "red", textAlign: "center" }}>خطا در بارگذاری واحدها: {error}</div>;
    }

    switch (props.route) {
        case "order":
            return <OrderComponent {...props} units_prop={units} />;

        case "cardShop":
            return <CardShopComponent {...props} units_prop={units} table_id={tableParam} />;

        case "search":
            return <SearchComponent {...props} units_prop={units} table_id={tableParam}/>;

        case "product_detail":
            return  <ProductDetailComponent id={props.product_id} tableId={tableParam}/>

        default:
            return <div>مسیر نامعتبر است.</div>;
    }
}
